export default "<main class=\"app-bg--ash-grey\">\n  <router-outlet></router-outlet>\n</main>\n"